/* Fleurity v2 — interações: calculadora, teste de tamanho, vídeos, "+" dos cards,
   escolha de tamanho, como usar animado, rastreio por CPF, contadores e entradas suaves. */
(function () {
  'use strict';
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- calculadora de economia ---- */
  function calc() {
    $$('[data-fl-calc]').forEach(function (sec) {
      var opts = $$('[data-fl-calc-opt]', sec), val = sec.querySelector('[data-fl-calc-value]');
      if (!opts.length || !val) return;
      var price = (parseInt(sec.dataset.cents, 10) || 7490) / 100, months = parseInt(sec.dataset.months, 10) || 36;
      var outA = sec.querySelector('[data-fl-calc-a]'), math = sec.querySelector('[data-fl-calc-math]'), bar = sec.querySelector('[data-fl-calc-bar]');
      var cur = parseFloat(String(val.textContent).replace(/\D/g, '')) || 0, raf;
      function fmt(v) { return Math.round(v).toLocaleString('pt-BR'); }
      function run() {
        var on = opts.filter(function (o) { return o.checked; })[0] || opts[0];
        var m = +on.value, total = m * months, target = Math.max(0, Math.floor(total - price));
        if (outA) outA.textContent = 'R$ ' + fmt(total);
        if (math) math.textContent = 'R$ ' + m + ' × ' + months + ' meses';
        if (bar) bar.style.width = Math.max(3, Math.min(100, price / total * 100)).toFixed(1) + '%';
        cancelAnimationFrame(raf);
        if (reduce) { cur = target; val.textContent = fmt(cur); return; }
        var from = cur, st = performance.now();
        (function step(now) { var k = Math.min(1, (now - st) / 450); k = 1 - Math.pow(1 - k, 3); cur = from + (target - from) * k; val.textContent = fmt(cur); if (k < 1) raf = requestAnimationFrame(step); })(st);
      }
      opts.forEach(function (o) { o.addEventListener('change', run); });
      run();
    });
  }

  /* ---- teste de tamanho ---- */
  function quiz() {
    $$('[data-fl-quiz]').forEach(function (sec) {
      var opts = $$('[data-fl-quiz-opt]', sec), res = $$('[data-fl-quiz-res]', sec);
      opts.forEach(function (b) {
        b.addEventListener('click', function () {
          var i = b.dataset.flQuizOpt;
          opts.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
          res.forEach(function (r) { r.hidden = r.dataset.flQuizRes !== i; });
        });
      });
    });
  }

  /* ---- vídeos: tocam sem som só enquanto aparecem na tela ---- */
  function reels() {
    var vids = $$('.fl-reel video');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && !reduce) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: .6 });
    vids.forEach(function (v) { v.muted = true; v.setAttribute('playsinline', ''); io.observe(v); });
  }

  /* ---- "+" dos cards: adiciona direto ao carrinho ---- */
  var toastT;
  function toast(msg) {
    var t = document.querySelector('.fl-toast');
    if (!t) { t = document.createElement('div'); t.className = 'fl-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('is-on'); }, 2200);
  }
  function openCart() {
    if (typeof window.upcartRefreshCart === 'function' || typeof window.upcartOpenCart === 'function') {
      try {
        var p = typeof window.upcartRefreshCart === 'function' ? window.upcartRefreshCart() : null;
        Promise.resolve(p).then(function () { if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart(); });
        return true;
      } catch (e) {}
    }
    return false;
  }
  function quickAdd() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('button[data-fl-quick]');
      if (!b || b.classList.contains('is-busy')) return;
      e.preventDefault();
      b.classList.add('is-busy');
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(b.dataset.flQuick), quantity: 1 }] })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          b.classList.remove('is-busy'); b.classList.add('is-done');
          if (b.hasAttribute('data-fl-quick-label')) b.textContent = 'Adicionado ao carrinho';
          else b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
          document.dispatchEvent(new CustomEvent('fl:cart-added'));
          if (!openCart()) toast('Adicionado ao carrinho');
        })
        .catch(function (err) { b.classList.remove('is-busy'); toast((err && (err.description || err.message)) || 'Não foi possível adicionar. Tente pela página do produto.'); });
    });
  }

  /* ---- barra fixa das landing pages ---- */
  function stickyCta() {
    var bar = document.querySelector('[data-fl-stickycta]');
    if (!bar) return;
    var after = parseInt(bar.dataset.after, 10) || 600;
    var offers = document.getElementById('ofertas');
    var offersOn = false;
    if (offers && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { offersOn = es[0].isIntersecting; tick(); }, { threshold: .15 }).observe(offers);
    }
    bar.hidden = false;
    function tick() { bar.classList.toggle('is-on', window.scrollY > after && !offersOn); }
    addEventListener('scroll', tick, { passive: true }); tick();
  }

  /* ---- janela de escolha de tamanho ---- */
  function sheets() {
    function lock(on) { document.documentElement.classList.toggle('fl-lock', on); }
    document.addEventListener('click', function (e) {
      var opener = e.target.closest && e.target.closest('[data-fl-sheet-open]');
      if (opener) {
        var d = document.getElementById(opener.getAttribute('data-fl-sheet-open'));
        if (!d) return;
        e.preventDefault();
        if (typeof d.showModal === 'function') { d.showModal(); } else { d.setAttribute('open', ''); d.classList.add('is-fallback'); }
        lock(true);
        try { (window.dataLayer = window.dataLayer || []).push({ event: 'fl_offer_open', offer: (d.querySelector('.fl-sheet__kick') || {}).textContent || '' }); } catch (x) {}
        return;
      }
      var closer = e.target.closest && e.target.closest('[data-fl-sheet-close]');
      var dlg = e.target.closest && e.target.closest('dialog.fl-sheet');
      if (closer && dlg) { close(dlg); if (closer.tagName !== 'A') e.preventDefault(); return; }
      if (e.target.matches && e.target.matches('dialog.fl-sheet')) close(e.target); /* clique fora do painel */
      var opt = e.target.closest && e.target.closest('.fl-sheet__opt');
      if (opt) { try { (window.dataLayer = window.dataLayer || []).push({ event: 'fl_offer_size', size: (opt.querySelector('.fl-sheet__size') || {}).textContent || '', url: opt.href }); } catch (x) {} }
    });
    function close(d) { if (typeof d.close === 'function' && d.open) d.close(); else d.removeAttribute('open'); lock(false); }
    $$('dialog.fl-sheet').forEach(function (d) { d.addEventListener('close', function () { lock(false); }); });
  }

  /* ---- como usar: anima o cartão visível e marca o ponto do carrossel ---- */
  function howto() {
    $$('[data-fl-howto]').forEach(function (rail) {
      var cards = $$('.fl-howto__card', rail);
      var dots = $$('i', rail.parentNode.querySelector('.fl-howto__dots') || document.createElement('div'));
      if (!('IntersectionObserver' in window)) { cards.forEach(function (c) { c.classList.add('is-on'); }); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { e.target.classList.toggle('is-on', e.isIntersecting && e.intersectionRatio > .55); });
        var idx = -1;
        cards.forEach(function (c, i) { if (idx < 0 && c.classList.contains('is-on')) idx = i; });
        dots.forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
      }, { threshold: [0, .56, 1] });
      cards.forEach(function (c) { io.observe(c); });
    });
  }

  /* ---- vídeo por cima da página ---- */
  function videoModal() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-fl-video]');
      if (!b) return;
      e.preventDefault();
      var d = document.createElement('dialog');
      d.className = 'fl-vmodal';
      d.innerHTML = '<button type="button" class="fl-vmodal__x" aria-label="Fechar"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button><video controls autoplay playsinline preload="auto"></video>';
      d.querySelector('video').src = b.getAttribute('data-fl-video');
      document.body.appendChild(d);
      function kill() { var v = d.querySelector('video'); if (v) { v.pause(); v.removeAttribute('src'); v.load(); } d.remove(); document.documentElement.classList.remove('fl-lock'); }
      d.addEventListener('close', kill);
      d.addEventListener('click', function (ev) { if (ev.target === d || ev.target.closest('.fl-vmodal__x')) { if (d.close) d.close(); else kill(); } });
      document.documentElement.classList.add('fl-lock');
      if (d.showModal) d.showModal(); else d.setAttribute('open', '');
    });
  }

  /* ---- rastreio por CPF (valida dígitos e abre o rastreio) ---- */
  function cpfOk(c) {
    c = String(c).replace(/\D/g, '');
    if (c.length !== 11 || /^(\d)\1{10}$/.test(c)) return false;
    var s = 0, i, d;
    for (i = 0; i < 9; i++) s += +c[i] * (10 - i);
    d = (s * 10) % 11; if (d === 10) d = 0; if (d !== +c[9]) return false;
    s = 0; for (i = 0; i < 10; i++) s += +c[i] * (11 - i);
    d = (s * 10) % 11; if (d === 10) d = 0; return d === +c[10];
  }
  function tracking() {
    $$('[data-fl-track]').forEach(function (box) {
      var form = box.querySelector('form'), inp = box.querySelector('input'), msg = box.querySelector('.fl-track__msg');
      var base = box.getAttribute('data-base') || '';
      if (!form || !inp) return;
      function mask(v) {
        v = v.replace(/\D/g, '').slice(0, 11);
        return v.replace(/^(\d{3})(\d)/, '$1.$2').replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3').replace(/\.(\d{3})(\d{1,2})$/, '.$1-$2');
      }
      function state(cls, text) { box.classList.remove('is-error', 'is-ok'); if (cls) box.classList.add(cls); msg.textContent = text || ''; }
      inp.addEventListener('input', function () {
        inp.value = mask(inp.value);
        var n = inp.value.replace(/\D/g, '');
        if (n.length < 11) state('', ''); else if (cpfOk(n)) state('is-ok', 'CPF válido. É só tocar em rastrear.'); else state('is-error', 'Esse CPF não parece válido. Confira os números.');
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var n = inp.value.replace(/\D/g, '');
        if (n.length !== 11) { state('is-error', 'Digite os 11 números do CPF.'); inp.focus(); return; }
        if (!cpfOk(n)) { state('is-error', 'Esse CPF não parece válido. Confira os números.'); inp.focus(); return; }
        state('is-ok', 'Abrindo o rastreio…');
        try { (window.dataLayer = window.dataLayer || []).push({ event: 'fl_tracking_submit' }); } catch (x) {}
        window.location.href = base.replace(/\/?$/, '/') + n;
      });
    });
  }

  /* ---- números que contam ao aparecer (92%, 4,9, +12.400…) ---- */
  function countUp() {
    var els = $$('.fl-stats__num, [data-fl-count]').filter(function (el) { return !el.closest('[data-fl-promise]'); });
    if (!els.length || reduce || !('IntersectionObserver' in window)) return;
    function textNode(el) {
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) if (/\d/.test(n.nodeValue)) return n;
      return null;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var node = textNode(e.target); if (!node) return;
        var orig = node.nodeValue, m = orig.match(/\d[\d.,]*/); if (!m) return;
        var tok = m[0].replace(/[.,]$/, ''), dec = 0, target;
        if (/,\d+$/.test(tok)) { dec = tok.split(',').pop().length; target = parseFloat(tok.replace(/\./g, '').replace(',', '.')); }
        else target = parseFloat(tok.replace(/[.,]/g, ''));
        if (!isFinite(target) || target === 0) return;
        var st = performance.now(), dur = 1100;
        (function step(now) {
          var k = Math.min(1, (now - st) / dur); k = 1 - Math.pow(1 - k, 3);
          var v = (target * k).toLocaleString('pt-BR', { minimumFractionDigits: dec, maximumFractionDigits: dec });
          node.nodeValue = orig.replace(m[0].replace(/[.,]$/, ''), v);
          if (k < 1) requestAnimationFrame(step); else node.nodeValue = orig;
        })(st);
      });
    }, { threshold: .6 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- seções entram suavemente ao rolar ---- */
  function reveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var secs = $$('#MainContent .shopify-section').slice(1);
    if (!secs.length) return;
    var vh = window.innerHeight;
    secs = secs.filter(function (s) { var f = s.firstElementChild; return f && f.classList.contains('fl') && !s.querySelector('.fl-stickycta, [data-fl-stickycta], dialog') && s.getBoundingClientRect().top > vh * .9 && s.offsetHeight > 40; });
    secs.forEach(function (s) { s.classList.add('fl-rv'); });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .01 });
    secs.forEach(function (s) { io.observe(s); });
    // rede de segurança: se o observador falhar (rolagem muito rápida, aba em segundo plano), nada fica invisível
    var tick = false;
    function sweep() {
      tick = false;
      var lim = window.innerHeight * 1.05;
      secs.forEach(function (s) { if (!s.classList.contains('is-in') && s.getBoundingClientRect().top < lim) { s.classList.add('is-in'); io.unobserve(s); } });
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(sweep); } }, { passive: true });
    setTimeout(function () { secs.forEach(function (s) { if (s.getBoundingClientRect().top < window.innerHeight * 2) s.classList.add('is-in'); }); }, 2500);
  }

  /* ---- texto antigo das páginas: some com parágrafos vazios que abriam buracos ---- */
  function prose() {
    $$('.fl-prose p, .fl-art__body p, .fl-rte p').forEach(function (p) {
      if (p.querySelector('img, iframe, video, svg, picture, input, button')) return;
      if (!p.textContent.replace(/[\u00a0\s]/g, '')) p.remove();
    });
  }

  /* ---- copiar cupom ---- */
  function copyCode() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-fl-copy]');
      if (!b) return;
      var code = b.getAttribute('data-fl-copy'), lab = b.querySelector('[data-fl-copy-label]') || b;
      function done() { var o = lab.textContent; lab.textContent = 'Copiado!'; b.classList.add('is-done'); setTimeout(function () { lab.textContent = o; b.classList.remove('is-done'); }, 1800); }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
      else { var t = document.createElement('textarea'); t.value = code; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (x) {} t.remove(); done(); }
    });
  }

  /* ---- contagem regressiva com data real (some quando acaba) ---- */
  function countdown() {
    $$('[data-fl-countdown]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-fl-countdown'));
      if (!end) { el.hidden = true; return; }
      var parts = { d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'), m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]') };
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var t = Math.max(0, end - Date.now());
        if (t <= 0) { var hide = el.closest('[data-fl-countdown-wrap]') || el; hide.hidden = true; clearInterval(iv); return; }
        var s = Math.floor(t / 1000);
        if (parts.d) parts.d.textContent = pad(Math.floor(s / 86400));
        if (parts.h) parts.h.textContent = pad(Math.floor(s % 86400 / 3600));
        if (parts.m) parts.m.textContent = pad(Math.floor(s % 3600 / 60));
        if (parts.s) parts.s.textContent = pad(s % 60);
      }
      var iv = setInterval(tick, 1000); tick();
    });
  }


  /* ---- busca na central de perguntas ---- */
  function faqSearch() {
    var inp = document.querySelector('[data-fl-faqsearch]');
    if (!inp) return;
    var items = $$('.fl-faqdb .fl-faq__item'), empty = document.querySelector('[data-fl-faqempty]');
    function norm(t) { return String(t).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
    var idx = items.map(function (it) { return norm(it.textContent); });
    var t;
    inp.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var q = norm(inp.value.trim()), any = false;
        items.forEach(function (it, i) { var ok = !q || idx[i].indexOf(q) > -1; it.hidden = !ok; if (ok) any = true; if (q && ok && q.length > 3) it.open = true; if (!q) it.open = false; });
        $$('.fl-faqdb .fl-faq').forEach(function (g) { var vis = $$('.fl-faq__item', g).some(function (x) { return !x.hidden; }); g.hidden = !vis; var h = g.previousElementSibling; if (h && h.classList.contains('fl-faqdb__sub')) h.hidden = !vis; });
        $$('[data-fl-faqtopic]').forEach(function (tp) { tp.hidden = !$$('.fl-faq__item', tp).some(function (x) { return !x.hidden; }); });
        if (empty) empty.hidden = any;
      }, 120);
    });
  }

  /* ---- promessa: números que entram por cima da foto e contam até o valor ---- */
  function countTo(el) {
    if (el.dataset.flCounting) return;
    var txt = (el.getAttribute('data-fl-count') || el.textContent).trim(), m = txt.match(/^(\d+(?:[.,]\d+)?)(.*)$/);
    if (!m || reduce) return;
    var raw = m[1], suf = m[2], dec = (raw.split(/[.,]/)[1] || '').length, sep = raw.indexOf(',') > -1 ? ',' : '.';
    var end = parseFloat(raw.replace(',', '.')), st = performance.now(), dur = 900;
    el.dataset.flCounting = '1';
    (function step(now) {
      var k = Math.min(1, (now - st) / dur); k = 1 - Math.pow(1 - k, 3);
      var v = (end * k).toFixed(dec); if (sep === ',') v = v.replace('.', ',');
      el.textContent = v + suf; if (k < 1) requestAnimationFrame(step); else { el.textContent = txt; delete el.dataset.flCounting; }
    })(st);
  }
  function promise() {
    var els = $$('[data-fl-promise]');
    if (!els.length) return;
    function show(e) { if (e.classList.contains('is-in')) return; e.classList.add('is-in'); $$('[data-fl-count]', e).forEach(countTo); }
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (x) { if (x.isIntersecting) { show(x.target); io.unobserve(x.target); } });
    }, { threshold: .3 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---- um dia com: a linha acende conforme a rolagem ---- */
  function day() {
    $$('[data-fl-day]').forEach(function (sec) {
      var list = sec.querySelector('[data-fl-day-list]');
      if (!list) return;
      var items = $$('[data-fl-day-item]', sec), ticking = false;
      if (reduce) { list.style.setProperty('--p', 1); items.forEach(function (i) { i.classList.add('is-on'); }); return; }
      function upd() {
        ticking = false;
        var r = list.getBoundingClientRect(), mark = innerHeight * .62;
        var p = Math.max(0, Math.min(1, (mark - r.top) / Math.max(1, r.height)));
        list.style.setProperty('--p', p.toFixed(3));
        items.forEach(function (it) { it.classList.toggle('is-on', it.getBoundingClientRect().top + 8 < mark); });
      }
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }
      addEventListener('scroll', onScroll, { passive: true });
      addEventListener('resize', onScroll);
      upd();
    });
  }

  function init() { calc(); quiz(); reels(); quickAdd(); stickyCta(); sheets(); howto(); videoModal(); tracking(); countUp(); reveal(); copyCode(); countdown(); faqSearch(); promise(); day(); prose(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
